<div class="wrapper-lg">
    <app-breadcrumbs [items]="[{ url: '/bc-contests', text: 'bcContest_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1 class="h-md" [translate]="'bcContest_listTitle'"></h1>
        <aside>
            <button class="btn btn-outline-primary" type="button" [routerLink]="['/bc-contests/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <app-table [rows]="items" [columns]="columns" [sticky]="'right'">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>{{row.Name}}</td>
                <td>
                    <app-bc-contest-status [value]="row.Status" [active]="row.IsActive"></app-bc-contest-status>
                </td>
                <td>
                    <div>{{row.OpenedFrom | appDate:'date'}}</div>
                    <small>{{row.OpenedFrom | appDate:'time'}}</small>
                </td>
                <td>
                    <div>{{row.OpenedTo | appDate:'date'}}</div>
                    <small>{{row.OpenedTo | appDate:'time'}}</small>
                </td>
                <td>
                    <div>{{row.ResultsVisibleFrom | appDate:'date'}}</div>
                    <small>{{row.ResultsVisibleFrom | appDate:'time'}}</small>
                </td>
                <td>
                    <div>{{row.ResultsVisibleTo | appDate:'date'}}</div>
                    <small>{{row.ResultsVisibleTo | appDate:'time'}}</small>
                </td>
                <td>
                    <div class="table-actions">
                        <button type="button" class="btn btn-outline btn-icon" [ngbTooltip]="'view' | translate"
                                [routerLink]="['/bc-contests', row.Id] | localize">
                            <i class="fi fi-rs-angle-right"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
